import { useContext } from 'react';
import isNil from 'lodash/isNil';
// local imports
import useCustomerSettings from '../config/customer';
import { GlobalContext } from '../context/global';

// `management_level` is the flat field from `/users/me/`; nil means the confirmation gate is off for that user
function useSkillLevelConfirmGate(): boolean {
  const { MANAGEMENT_LEVEL_SKILL_CONFIRM } = useCustomerSettings();
  const { user: { data: user } } = useContext(GlobalContext);
  const { management_level } = user || {};
  return MANAGEMENT_LEVEL_SKILL_CONFIRM >= 1 && !isNil(management_level) &&
    management_level < MANAGEMENT_LEVEL_SKILL_CONFIRM;
}

export default useSkillLevelConfirmGate;
